import React, { useEffect } from 'react'
import { ContainerGeneral } from './styles'
import { Tabs, withDashboardLoader } from '~/components/shared'
import { GeneralContent, GeneralHeader } from '~/components/generalMedicalView'
import { GeneralHealthProceduresProvider, usePatient } from '~/context'
import { useDocumentTitle, useEvolutionReport, useMaternalInfantViewSettings } from '~/hooks'
import { message } from '~/services'
import { EvolutionReport } from '~/components/generalMedicalView/evolutionReport'

const GeneralMedicalViewPage = (): JSX.Element => {
  useDocumentTitle(message('titles.timeline_general'))
  const { resetPatientTag, patient } = usePatient()
  const { cleanupMaternalInfantViewSettings } = useMaternalInfantViewSettings()
  const { data } = useEvolutionReport({
    medicalRecord: patient?.medicalRecord,
    patientName: patient?.name
  })

  useEffect(() => {
    resetPatientTag()
    cleanupMaternalInfantViewSettings()
  }, [cleanupMaternalInfantViewSettings, resetPatientTag])

  return (
    <GeneralHealthProceduresProvider>
      <Tabs>
        <Tabs.Options>
          <Tabs.Item>{message('timeline.general_medical_view')}</Tabs.Item>
          <Tabs.Item>{message('historyLaboratoryTests.title')}</Tabs.Item>
        </Tabs.Options>

        <Tabs.Content>
          <ContainerGeneral>
            <GeneralHeader />
            <GeneralContent />
          </ContainerGeneral>

          <EvolutionReport url={data?.examConsumptionAppUrl} />
        </Tabs.Content>
      </Tabs>
    </GeneralHealthProceduresProvider>
  )
}

export const GeneralMedicalView = withDashboardLoader(GeneralMedicalViewPage)
